module.exports = "<div class=\"login-box\">\r\n  <div class=\"login-logo\">\r\n    <a><b>Sign</b>Labs</a>\r\n  </div>\r\n  <!-- /.login-logo -->\r\n  <div class=\"login-box-body\">\r\n    <p class=\"login-box-msg\">Sign in to start your session</p>\r\n    <div ui-view></div>\r\n  </div>\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/auth/auth.html
 ** module id = 15
 ** module chunks = 0
 **/